import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-busca-pesquisavel',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './busca-pesquisavel.component.html',
  styleUrls: ['./busca-pesquisavel.component.css']
})
export class BuscaPesquisavelComponent {
  @Input() termo = '';
  @Input() nomeCampo = 'buscaPesquisavel';
  @Input() placeholder = 'Digite ao menos 3 caracteres';
  @Input() rotuloBuscar = 'Pesquisar';
  @Input() itens: unknown[] = [];
  @Input() rotuloItem: (item: unknown) => string = () => '';
  @Input() detalheItem: (item: unknown) => string = () => '';
  @Output() termoChange = new EventEmitter<string>();
  @Output() digitou = new EventEmitter<string>();
  @Output() buscar = new EventEmitter<void>();
  @Output() selecionar = new EventEmitter<unknown>();

  alterarTermo(valor: string) {
    this.termo = valor;
    this.termoChange.emit(valor);
    this.digitou.emit(valor);
  }

  limparTermo() {
    this.alterarTermo('');
  }
}
